import 'element-ui/packages/theme-chalk/src/tree.scss'
import Tree from './src/tree.vue'

/* istanbul ignore next */
Tree.install = function (Vue) {
  Vue.component(Tree.name, Tree)
}

export default Tree
